module.exports = __webpack_public_path__ + "img/41-cowboy.ff3913df.svg";